import { AppService } from './app.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(_service, _router, router, spinnerService) {
        this._service = _service;
        this._router = _router;
        this.router = router;
        this.spinnerService = spinnerService;
        this.loginData = { username: "", password: "" };
        this.maskedPhone = "";
        this.typeSelected = 'ball-fussion';
    }
    LoginComponent.prototype.ngOnInit = function () {
        this.loginData.username = this._router.snapshot.params['username'];
        this.maskedPhone = this.maskPhoneNumber(this.loginData.username);
    };
    LoginComponent.prototype.maskPhoneNumber = function (phone) {
        if (!phone)
            return "";
        if (phone.length <= 4)
            return phone;
        var masked = phone.substring(0, 3) + "****" + phone.substring(phone.length - 3);
        return masked;
    };
    LoginComponent.prototype.showSpinner = function () {
        this.spinnerService.show();
        // setTimeout(() => {
        //  this.spinnerService.hide();
        // }, 5000); // 5 seconds
    };
    LoginComponent.prototype.register = function () {
        this.router.navigate(['/register']);
    };
    LoginComponent.prototype.resendCode = function () {
        this.showSpinner();
        alert('New verification code has been sent to your phone');
        this.spinnerService.hide();
        // Could implement actual resend logic here
        // this._service.preLogin({phone: this.loginData.username, pin: "resend", recaptchaResponse: ""});
    };
    LoginComponent.prototype.login = function () {
        this.showSpinner();
        if (this.loginData.username.indexOf('+') != -1) {
            this.loginData.username = this.loginData.username.substring(1);
        }
        if (this.loginData.username.substring(0, 2) == "00") {
            this.loginData.username = this.loginData.username.substring(2);
        }
        console.log(this.loginData);
        this._service.obtainAccessToken(this.loginData);
    };
    return LoginComponent;
}());
export { LoginComponent };
